import { Seo } from '../seo/Seo'
import { InstagramFeed } from './InstagramFeed'
import './Instagram.css'

export const InstagramFeedSection = ({ counter = 9 }) => {
  return (
    <section className="instagram-feed-section" aria-labelledby="instagram-heading">
      <h3 id="instagram-heading">INSTAGRAM</h3>
      <InstagramFeed counter={counter} />
      <a
        className="instagram-profile-link"
        href="https://www.instagram.com/valerekissi_cinematographer/"
        target="_blank"
        rel="noreferrer"
      >
        View all posts on Instagram
      </a>
    </section>
  );
}

export const Instagram = () => {
  return <div className="instagram-page">
  <Seo
    title="Instagram — Valere Kissi | Cinematographer in Sioux Falls, SD"
    description="Latest Instagram posts from Valere Kissi, cinematographer and photographer in Sioux Falls, South Dakota."
    path="/instagram"
  />
  <InstagramFeedSection counter="9" />
  </div>
}
